export const AZURE_AD_CLIENT_ID: string = process.env.REACT_APP_AZURE_AD_CLIENT_ID ?? '';
export const TENANT_URL: string = process.env.REACT_APP_TENANT_URL ?? '';
if (!AZURE_AD_CLIENT_ID || !TENANT_URL) {
  alert("Missing environment variables AZURE_AD_CLIENT_ID: " + AZURE_AD_CLIENT_ID + " and TENANT_URL:" + TENANT_URL);
}

// Not in use DEV
// export const AZURE_AD_CLIENT_ID = 'd85e9419-806b-4c35-9f62-d5fff7a75b89';
// export const TENANT_URL = 'https://login.microsoftonline.com/4f80b5dd-0f05-4843-be6d-e6544e03660a';

// DEV
//   export const AZURE_AD_CLIENT_ID = '98dc6f71-84c5-49bb-a9c8-43e39f30406d';
//   export const TENANT_URL = 'https://login.microsoftonline.com/cd62b7dd-4b48-44bd-90e7-e143a22c8ead';

// QA
// export const AZURE_AD_CLIENT_ID = '98dc6f71-84c5-49bb-a9c8-43e39f30406d';
// export const TENANT_URL = 'https://login.microsoftonline.com/cd62b7dd-4b48-44bd-90e7-e143a22c8ead';

// UAT
// export const AZURE_AD_CLIENT_ID = '98dc6f71-84c5-49bb-a9c8-43e39f30406d';
// export const TENANT_URL = 'https://login.microsoftonline.com/cd62b7dd-4b48-44bd-90e7-e143a22c8ead';

// prod
// export const AZURE_AD_CLIENT_ID = '2df7f642-791c-4f9b-bbec-c01ff38e3693';
// export const TENANT_URL = 'https://login.microsoftonline.com/cd62b7dd-4b48-44bd-90e7-e143a22c8ead';
